// extracted by mini-css-extract-plugin
export default {"product":"Product_product__2Wvm1","product_img":"Product_product_img__Yqcdf"};